import { Auth0Provider, useAuth0 } from '@auth0/auth0-react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import App from 'App';
import { setAuthContextOnBackendService } from 'BackendAuthHandler';
import React, { useLayoutEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Palette } from 'Palette';
import { MUI_COMPONENT_OVERRIDES } from 'DesignTokens';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { googleAnalyticsService } from './services/GoogleAnalyticsService';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Route selection based on pathname
const RootComponent = App;
// Initialize Google Analytics for non-admin app only
if (RootComponent === App) {
  googleAnalyticsService.initializeFromEnv();
}

const theme = createTheme({ components: MUI_COMPONENT_OVERRIDES });

const domain = process.env.REACT_APP_AUTH0_DOMAIN!;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID!;
const authorizationParams = {
  redirect_uri: `${window.location.origin}/forward`,
  audience: process.env.REACT_APP_BACKEND_AUDIENCE,
};
console.log('Auth0 config:', { domain, clientId, authorizationParams });

/** Wire `useAuth0` for BackendAuthHandler on every route (including /impersonate), not only inside CheckLoginComponent. */
function SyncAuth0ToBackendAuthHandler() {
  const auth0 = useAuth0();
  useLayoutEffect(() => {
    setAuthContextOnBackendService(auth0);
  }, [auth0]);
  return null;
}

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <Helmet>
          <title>{process.env.REACT_APP_PRODUCT_NAME}</title>
          <link rel="icon" type="image/png" href="/assets/favicon.png" />
          <style>
            {`
          body {
            background-color: ${Palette.body.background};
            ${Palette.body.fontFamily ? `font-family: ${Palette.body.fontFamily};` : ''}
          }
html {
  font-size: 100%; /* default = 16px */
}

@media (max-width: 600px) {
  html {
    font-size: 75%; /* 14px = 0.875 * 16px */
    /* or 62.5% for 10px = easy rem math */
  }
}

@media print {
  .hide-print {
    display: none !important;
  }
}


        `}
          </style>
        </Helmet>
        <Auth0Provider
          domain={domain}
          clientId={clientId}
          authorizationParams={authorizationParams}
          cacheLocation="localstorage"
          useRefreshTokens={true}
          useRefreshTokensFallback={true}
        >
          <SyncAuth0ToBackendAuthHandler />
          <RootComponent />
        </Auth0Provider>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
